import { useEffect, useState } from "react";
import { getTopTips, getStaffPhotos } from "../services/API";
import CardLayout4 from "./CardLayout4";
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import type { cards, topTipItem, staffPhotoItem } from "../Types";

const TopTipsContainer: React.FC<cards>= ({title}) => {
    
    const [topTips, setTopTips] = useState([]);
    const [staffPhotos, setStaffPhotos] = useState<staffPhotoItem[]>([]);

    const initData = async () => {
        const tipsData = await getTopTips()
        if (tipsData) {
            setTopTips(tipsData)

            const nameList = tipsData.map((staff: topTipItem) => {
                return staff.Consultant
            }) 
            const staffData = await getStaffPhotos(nameList)
            if (staffData) {
                setStaffPhotos(staffData)
            }
        }
    }

    useEffect(() => {
        initData()
    }
    ,[])

    // Match st_name from people collection with consultantName from holidaytips collection
    const getConsultantPhotoUrl = (consultantName: string): string | undefined => {
        const staffMember = staffPhotos.find(staff => staff.st_name === consultantName);
        const photoURL = `https://www.trailfinders.com/staffphotos.nsf/(LULogName)/${staffMember?.st_logname}/$file/${staffMember?.st_logname}.jpg`;
        return photoURL;
    };

    return (
        <>
        { topTips.length ? 
            <section id="toptips" className="app-section container-fluid position-relative overflow-hidden min-vh-50 py-4 px-0">
                <div className="position-relative container py-5 py-md-3 px-4 px-md-2">

                    <div className="row pb-4 pb-md-5">
                        <h2 className="fw-bold text-white fs-4 fs-md-4 col">{title}</h2>
                    </div>
                
                        
                    {/* Top tips Carousel */}
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={10}
                        slidesPerView={1.2}
                        loop={false}
                        wrapperClass="d-flex align-items-stretch"
                        className="mySwiper h-100"
                        navigation={{nextEl : '#swiperForward', prevEl : '#swiperBack'}}
                        breakpoints={{
                            640: {
                                slidesPerView: 1.2,
                                spaceBetween: 14
                            },
                            768: {
                                slidesPerView: 1.5,
                                spaceBetween: 14
                            },
                            1024: {
                                slidesPerView: 2.2,
                                spaceBetween: 14
                            },
                            2480: {
                                slidesPerView: 2.2,
                                spaceBetween: 14
                            },

                        }}
                    >
                    
                        <div className="h-100">
                            {topTips.map((toptip: topTipItem) => {
                                return (
                                    <SwiperSlide key={toptip.Consultant} className="d-flex h-auto">
                                        <CardLayout4
                                            consultant={toptip.Consultant}
                                            details={toptip.Details}
                                            photoUrl={getConsultantPhotoUrl(toptip.Consultant)}
                                        />
                                    </SwiperSlide>
                                )
                            })}
                        </div>

                        <div className='d-none d-lg-flex gap-3 pt-5 align-items-center justify-content-center'>
                            <button
                                id="swiperBack"
                                className="btn btn-light d-flex algin-items-center justify-content-center shadow-sm p-3"
                                type="button"
                            >
                                <i className="icon-chevron_left glyph-sm" role="back button"></i>
                            </button>
                                
                            <button
                                id="swiperForward"
                                className="btn btn-light d-flex algin-items-center justify-content-center shadow-sm p-3"
                                type="button"
                            >
                                <i className="icon-chevron_right glyph-sm" role="next button"></i>
                            </button>    
                        </div>

                    </Swiper>
                </div>
            </section>  
        : " "}  
        </>
    )
}

export default TopTipsContainer